import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { positiveInt32Schema } from './schemas/positiveInt32Schema';

export interface INzaServiceDeclarationActivityAddEditValidated {
    endDate: Date | null;
    nzaServiceDeclarationRuleId: string;
    serviceDeclarationActivityId: string;
    startDate: Date;
    supplementPriceActivity: number;
}

const nzaServiceDeclarationActivityEdit = Koi.object({
    endDate: Koi.koi().date().endDate().allow(null),
    serviceDeclarationActivityId: Koi.string().uuid(),
    startDate: Koi.koi().date(),
    supplementPriceActivity: positiveInt32Schema.allow(null),
}).options({ convert: false, presence: 'required' });

export const nzaServiceDeclarationActivityEditSchema: ISchemaContainer<INzaServiceDeclarationActivityAddEditValidated> =
    {
        schema: nzaServiceDeclarationActivityEdit,
    };

export const nzaServiceDeclarationActivityAddSchema: ISchemaContainer<INzaServiceDeclarationActivityAddEditValidated> =
    {
        schema: nzaServiceDeclarationActivityEdit.concat(
            Koi.object({
                nzaServiceDeclarationRuleId: Koi.string().uuid(),
            }).options({ convert: false, presence: 'required' })
        ),
    };
